import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { renderItemDescriptionHtml } from '@modules/common/utils/item-description-html';

/**
 * A stitch item's `description` as formatted text: sanitized to the shared allow-list, every link
 * opening in a new tab, with the list markers, margins and link colour the Tailwind reset takes away.
 *
 * It is the only way the app renders a description, so the trust boundary cannot be bypassed: the
 * stored value is never believed, it is sanitized again here before it reaches `[innerHTML]`.
 *
 * **Not a general HTML viewer.** It keeps only what a calendar event body may contain — a mail body
 * rendered here would lose its tables, images, fonts and styling.
 *
 * Why a component rather than a stylesheet: `[innerHTML]` children are created at runtime and carry
 * no encapsulation attribute, so no ordinary component rule can reach them. Holding that one
 * `::ng-deep` here keeps it out of every caller and emits nothing globally.
 */
@Component({
  selector: 'stch-item-description',
  template: '<div [innerHTML]="rendered()"></div>',
  styleUrl: './item-description.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemDescriptionComponent {
  /** The stored description. */
  public readonly html = input<string | null>();

  protected readonly rendered = computed(() => renderItemDescriptionHtml(this.html()));
}
